export function capitalizeWords(str) {
    const words = str.split(' ');

    const capitalizedWords = words.map((word) => {
        return `${word.charAt(0).toUpperCase()}${word.slice(1)}`;
    });
    
    return capitalizedWords.join(' ');
}

// thank you to https://stackoverflow.com/questions/2970525/converting-any-string-into-camel-case
export function camelize(str,upperCamel = false) {
    return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
      if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
    //   if upper camel, the first letter is caps, otherwise it's lower
      return index === 0 && !upperCamel ? match.toLowerCase() : match.toUpperCase();
    });
  }